import { createSlice } from "@reduxjs/toolkit";
import store from "redux/store";

/**
 *
 * @type AccountStoreAccount
 */
const initialState = {
  accountList: { loading: false, data: null, error: null },
  accountCompanyList: { loading: false, data: null, error: null },
  createAccount: { loading: false, data: null, error: null },
  updateAccount: { loading: false, data: null, error: null },
  accountDropDownList: { loading: false, data: null, error: null },
  accountgetById: { loading: false, data: null, error: null },
  locationAccountList: { loading: false, data: null, error: null },
  generateClientId: { loading: false, data: null, error: null },
  generateClientDm: { loading: false, data: null, error: null },

  accountProfileList: { loading: false, data: null, error: null },
  createAccountProfile: { loading: false, data: null, error: null },
  createAccountDetails:{ loading: false, data: null, error: null },
  updateSDWaiveOff: { loading: false, data: null, error: null },
  updateSDDue: { loading: false, data: null, error: null },
  clientAccountIdAgreementList: { loading: false, data: null, error: null },
  accountBookingList: { loading: false, data: null, error: null },
  bookingByAccountList: { loading: false, data: null, error: null },
  syncMemberData: { loading: false, data: null, error: null },

  agreementDataForAccount: { loading: false, data: null, error: null },
  ProposalDataForAccount: { loading: false, data: null, error: null },
  ProposalDataForAccountGenerate: { loading: false, data: null, error: null },
  ProposalDataUpdate: { loading: false, data: null, error: null },
  ProposalDataForOtView: { loading: false, data: null, error: null },
};

export const AccountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    fetchAccountListRequest: (state, action) => {
      state.accountList.loading = true;
      state.accountList.error = null;
    },
    fetchAccountListSuccess: (state, action) => {
      state.accountList.data = action.payload;
      state.accountList.loading = false;
      state.accountList.error = null;
    },
    fetchAccountListFailure: (state, action) => {
      state.accountList.data = null;
      state.accountList.loading = false;
      state.accountList.error = action.payload;
    },
    fetchAccountCompanyListRequest: (state, action) => {
      state.accountCompanyList.loading = true;
      state.accountCompanyList.error = null;
    },
    fetchAccountCompanyListSuccess: (state, action) => {
      state.accountCompanyList.data = action.payload;
      state.accountCompanyList.loading = false;
      state.accountCompanyList.error = null;
    },
    fetchAccountCompanyListFailure: (state, action) => {
      state.accountCompanyList.data = null;
      state.accountCompanyList.loading = false;
      state.accountCompanyList.error = action.payload;
    },
    createAccountRequest: (state, action) => {
      state.createAccount.loading = true;
      state.createAccount.error = null;
    },
    createAccountSuccess: (state, action) => {
      state.createAccount.data = action.payload;
      state.createAccount.loading = false;
      state.createAccount.error = null;
      state.accountList = addNewAccountSuccess(action.payload, {
        ...state.accountList,
      });
    },
    createAccountFailure: (state, action) => {
      state.createAccount.data = null;
      state.createAccount.loading = false;
      state.createAccount.error = action.payload;
    },
    updateAccountRequest: (state, action) => {
      state.updateAccount.loading = true;
      state.updateAccount.error = null;
    },
    updateAccountSuccess: (state, action) => {
      state.updateAccount.data = action.payload;
      state.updateAccount.loading = false;
      state.updateAccount.error = null;
      state.accountList = updateAccountListSuccess(action.payload, {
        ...state.accountList,
      });
    },
    updateAccountFaliure: (state, action) => {
      state.updateAccount.data = null;
      state.updateAccount.loading = false;
      state.updateAccount.error = action.payload;
    },
    fetchAccountDropDownListRequest: (state, action) => {
      state.accountDropDownList.loading = true;
      state.accountDropDownList.error = null;
    },
    fetchAccountDropDownListSuccess: (state, action) => {
      state.accountDropDownList.data = action.payload;
      state.accountDropDownList.loading = false;
      state.accountDropDownList.error = null;
    },
    fetchAccountDropDownListFailure: (state, action) => {
      state.accountDropDownList.data = null;
      state.accountDropDownList.loading = false;
      state.accountDropDownList.error = action.payload;
    },
    accountByIdRequest: (state, action) => {
      state.accountgetById.loading = true;
      state.accountgetById.error = null;
    },
    accountByIdSuccess: (state, action) => {
      state.accountgetById.data = action.payload;
      state.accountgetById.loading = false;
      state.accountgetById.error = null;
    },
    accountByIdFailure: (state, action) => {
      state.accountgetById.data = null;
      state.accountgetById.loading = false;
      state.accountgetById.error = action.payload;
    },
    fetchLocationAccountListRequest: (state, action) => {
      state.locationAccountList.loading = true;
      state.locationAccountList.error = null;
    },
    fetchLocationAccountListSuccess: (state, action) => {
      state.locationAccountList.data = action.payload;
      state.locationAccountList.loading = false;
      state.locationAccountList.error = null;
    },
    fetchLocationAccountListFailure: (state, action) => {
      state.locationAccountList.data = null;
      state.locationAccountList.loading = false;
      state.locationAccountList.error = action.payload;
    },
    generateClientIdRequest: (state, action) => {
      state.generateClientId.loading = true;
      state.generateClientId.error = null;
    },
    generateClientDmRequest: (state, action) => {
      state.generateClientDm.loading = true;
      state.generateClientDm.error = null;
    },
    generateClientDmSuccess: (state, action) => {
      state.generateClientDm.data = action.payload;
      state.generateClientDm.loading = false;
      state.generateClientDm.error = null;
    },
    generateClientDmFailure: (state, action) => {
      state.generateClientDm.data = null;
      state.generateClientDm.loading = false;
      state.generateClientDm.error = action.payload;
    },
    generateClientIdSuccess: (state, action) => {
      state.generateClientId.data = action.payload;
      state.generateClientId.loading = false;
      state.generateClientId.error = null;
    },
    generateClientIdFailure: (state, action) => {
      state.generateClientId.data = null;
      state.generateClientId.loading = false;
      state.generateClientId.error = action.payload;
    },

    // fetch update account Profile data
    fetchAccountProfileListRequest: (state, action) => {
      state.accountProfileList.loading = true;
      state.accountProfileList.error = null;
    },
    fetchAccountProfileListSuccess: (state, action) => {
      state.accountProfileList.data = action.payload;
      state.accountProfileList.loading = false;
      state.accountProfileList.error = null;
    },
    fetchAccountProfileListFailure: (state, action) => {
      state.accountProfileList.data = null;
      state.accountProfileList.loading = false;
      state.accountProfileList.error = action.payload;
    },

    // Add UpdateAccount Profile
    UpdateAccountProfileRequest: (state, action) => {
      state.createAccountProfile.loading = true;
      state.createAccountProfile.error = null;
    },
    UpdateAccountProfileSuccess: (state, action) => {
      state.createAccountProfile.data = action.payload;
      state.createAccountProfile.loading = false;
      state.createAccountProfile.error = null;
      state.accountProfileList = createNewAccountProfileListSuccess(
        action.payload,
        {
          ...state.accountProfileList,
        }
      );
    },
    UpdateAccountProfileFaliure: (state, action) => {
      state.createAccountProfile.data = null;
      state.createAccountProfile.loading = false;
      state.createAccountProfile.error = action.payload;
    },

    // Add Account Details
    CreateAccountDetailsRequest: (state, action) => {
      state.createAccountDetails.loading = true;
      state.createAccountDetails.error = null;
    },
    CreateAccountDetailsSuccess: (state, action) => {
      state.createAccountDetails.data = action.payload;
      state.createAccountDetails.loading = false;
      state.createAccountDetails.error = null;
      // state.accountProfileList = createNewAccountProfileListSuccess(
      //   action.payload,
      //   {
      //     ...state.accountProfileList,
      //   }
      // );
    },
    CreateAccountDetailsFaliure: (state, action) => {
      state.createAccountDetails.data = null;
      state.createAccountDetails.loading = false;
      state.createAccountDetails.error = action.payload;
    },


    // Edit/Update Account Profile
    editUpdateAccountProfileRequest: (state, action) => {
      state.createAccountProfile.loading = true;
      state.createAccountProfile.error = null;
    },
    editUpdateAccountProfileSuccess: (state, action) => {
      state.createAccountProfile.data = action.payload;
      state.createAccountProfile.loading = false;
      state.createAccountProfile.error = null;
      state.accountProfileList = editAccountProfileListSuccess(action.payload, {
        ...state.accountProfileList,
      });
    },
    editUpdateAccountProfileFaliure: (state, action) => {
      state.createAccountProfile.data = null;
      state.createAccountProfile.loading = false;
      state.createAccountProfile.error = action.payload;
    },
    resetAccount: (data, action) => {
      data.generateClientId.data = null;
      data.generateClientId.error = null;
      data.generateClientId.loading = false;
    },

    // SD Waive off Update
    updateSDWaiveOffRequest: (state, action) => {
      state.updateSDWaiveOff.loading = true;
      state.updateSDWaiveOff.error = null;
    },
    updateSDWaiveOffSuccess: (state, action) => {
      state.updateSDWaiveOff.data = action.payload;
      state.updateSDWaiveOff.loading = false;
      state.updateSDWaiveOff.error = null;
      state.accountList = updateSDWaiveOffListSuccess(action.payload, {
        ...state.accountList,
      });
    },
    updateSDWaiveOffFaliure: (state, action) => {
      state.updateSDDue.data = null;
      state.updateSDDue.loading = false;
      state.updateSDDue.error = action.payload;
    },

    updateSDDueRequest: (state, action) => {
      state.updateSDDue.loading = true;
      state.updateSDDue.error = null;
    },
    updateSDDueSuccess: (state, action) => {
      state.updateSDDue.data = action.payload;
      state.updateSDDue.loading = false;
      state.updateSDDue.error = null;
      state.accountList = updateSDDueListSuccess(action.payload, {
        ...state.accountList,
      });
    },
    updateSDDueFaliure: (state, action) => {
      state.updateSDDue.data = null;
      state.updateSDDue.loading = false;
      state.updateSDDue.error = action.payload;
    },
    fetchClientAccountIdAgreementListRequest: (state, action) => {
      state.clientAccountIdAgreementList.loading = true;
      state.clientAccountIdAgreementList.error = null;
    },
    fetchClientAccountIdAgreementListSuccess: (state, action) => {
      state.clientAccountIdAgreementList.data = action.payload;
      state.clientAccountIdAgreementList.loading = false;
      state.clientAccountIdAgreementList.error = null;
    },
    fetchClientAccountIdAgreementListFaliure: (state, action) => {
      state.clientAccountIdAgreementList.data = null;
      state.clientAccountIdAgreementList.loading = false;
      state.clientAccountIdAgreementList.error = action.payload;
    },
    fetchAgreementDataForAccountRequest: (state, action) => {
      state.agreementDataForAccount.loading = true;
      state.agreementDataForAccount.error = null;
    },
    fetchAgreementDataForAccountSuccess: (state, action) => {
      state.agreementDataForAccount.data = action.payload;
      state.agreementDataForAccount.loading = false;
      state.agreementDataForAccount.error = null;
    },
    fetchAgreementDataForAccountFailure: (state, action) => {
      state.agreementDataForAccount.data = null;
      state.agreementDataForAccount.loading = false;
      state.agreementDataForAccount.error = action.payload;
    },
    fetchClientAccountProposalListRequest: (state, action) => {
      state.ProposalDataForAccount.loading = true;
      state.ProposalDataForAccount.error = null;
    },
    fetchClientAccountProposalListSuccess: (state, action) => {
      state.ProposalDataForAccount.data = action.payload;
      state.ProposalDataForAccount.loading = false;
      state.ProposalDataForAccount.error = null;
    },
    fetchClientAccountProposalListFailure: (state, action) => {
      state.ProposalDataForAccount.data = null;
      state.ProposalDataForAccount.loading = false;
      state.ProposalDataForAccount.error = action.payload;
    },

    fetchProposalClientByIdRequest: (state, action) => {
      state.ProposalDataForAccountGenerate.loading = true;
      state.ProposalDataForAccountGenerate.error = null;
    },
    fetchProposalClientByIdSuccess: (state, action) => {
      state.ProposalDataForAccountGenerate.data = action.payload;
      state.ProposalDataForAccountGenerate.loading = false;
      state.ProposalDataForAccountGenerate.error = null;
    },
    fetchProposalClientByIdFailure: (state, action) => {
      state.ProposalDataForAccountGenerate.data = null;
      state.ProposalDataForAccountGenerate.loading = false;
      state.ProposalDataForAccountGenerate.error = action.payload;
    },

    fetchProposalClientByIdOtViewRequest: (state, action) => {
      state.ProposalDataForOtView.loading = true;
      state.ProposalDataForOtView.error = null;
    },
    fetchProposalClientByIdOtViewSuccess: (state, action) => {
      state.ProposalDataForOtView.data = action.payload;
      state.ProposalDataForOtView.loading = false;
      state.ProposalDataForOtView.error = null;
    },
    fetchProposalClientByIdOtViewFailure: (state, action) => {
      state.ProposalDataForOtView.data = null;
      state.ProposalDataForOtView.loading = false;
      state.ProposalDataForOtView.error = action.payload;
    },

    createProposalAccountRequest: (state, action) => {
      state.ProposalDataUpdate.loading = true;
      state.ProposalDataUpdate.error = null;
    },
    createProposalAccountSuccess: (state, action) => {
      state.ProposalDataUpdate.data = action.payload;
      state.ProposalDataUpdate.loading = false;
      state.ProposalDataUpdate.error = null;
    },
    createProposalAccountFailure: (state, action) => {
      state.ProposalDataUpdate.data = null;
      state.ProposalDataUpdate.loading = false;
      state.ProposalDataUpdate.error = action.payload;
    },
    
    fetchAccountBookingListRequest: (state, action) => {
      state.accountBookingList.loading = true;
      state.accountBookingList.error = null;
    },
    fetchAccountBookingListSuccess: (state, action) => {
      state.accountBookingList.data = action.payload;
      state.accountBookingList.loading = false;
      state.accountBookingList.error = null;
    },
    fetchAccountBookingListFaliure: (state, action) => {
      state.accountBookingList.data = null;
      state.accountBookingList.loading = false;
      state.accountBookingList.error = action.payload;
    },
    fetchBookingByAccountListRequest: (state, action) => {
      state.bookingByAccountList.loading = true;
      state.bookingByAccountList.error = null;
    },
    fetchBookingByAccountListSuccess: (state, action) => {
      state.bookingByAccountList.data = action.payload;
      state.bookingByAccountList.loading = false;
      state.bookingByAccountList.error = null;
    },
    fetchBookingByAccountListFaliure: (state, action) => {
      state.bookingByAccountList.data = null;
      state.bookingByAccountList.loading = false;
      state.bookingByAccountList.error = action.payload;
    },

    syncFailedMemberRequest: (state, action) => {
      state.syncMemberData.loading = true;
      state.syncMemberData.error = null;
    },
    syncFailedMemberSuccess: (state, action) => {
      state.syncMemberData.data = action.payload;
      state.syncMemberData.loading = false;
      state.syncMemberData.error = null;
    },
    syncFailedMemberFaliure: (state, action) => {
      state.syncMemberData.data = null;
      state.syncMemberData.loading = false;
      state.syncMemberData.error = action.payload;
    },

  },
});
function addNewAccountSuccess(dataToUpdate, state) {
  state.data.data = [dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}
function updateAccountListSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });
  return state;
}
function createNewAccountProfileListSuccess(dataToUpdate, state) {
  state.data.data = [dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}
// editAccountProfileListSuccess
function editAccountProfileListSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((data) => {
    if (data._id !== dataToUpdate._id) return data;
    return { ...data, ...dataToUpdate };
  });
  return state;
}

// SD WaiveOFF updateSDWaiveOffListSuccess
function updateSDWaiveOffListSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });
  return state;
}

function updateSDDueListSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });
  return state;
}

export const {
  createAccountRequest,
  createAccountSuccess,
  createAccountFailure,
  fetchAccountListRequest,
  fetchAccountListSuccess,
  fetchAccountListFailure,
  fetchAccountCompanyListRequest,
  fetchAccountCompanyListSuccess,
  fetchAccountCompanyListFailure,
  updateAccountRequest,
  updateAccountSuccess,
  updateAccountFaliure,
  fetchAccountDropDownListRequest,
  fetchAccountDropDownListSuccess,
  fetchAccountDropDownListFailure,
  accountByIdRequest,
  accountByIdSuccess,
  accountByIdFailure,
  fetchLocationAccountListRequest,
  fetchLocationAccountListSuccess,
  fetchLocationAccountListFailure,
  generateClientIdRequest,
  generateClientIdSuccess,
  generateClientIdFailure,
  generateClientDmRequest,
  generateClientDmFailure,
  generateClientDmSuccess,
  fetchAccountProfileListRequest,
  fetchAccountProfileListSuccess,
  fetchAccountProfileListFailure,
  UpdateAccountProfileRequest,
  UpdateAccountProfileSuccess,
  UpdateAccountProfileFaliure,
  CreateAccountDetailsRequest,
  CreateAccountDetailsSuccess,
  CreateAccountDetailsFaliure,
  editUpdateAccountProfileRequest,
  editUpdateAccountProfileSuccess,
  editUpdateAccountProfileFaliure,
  resetAccount,

  updateSDWaiveOffRequest,
  updateSDWaiveOffSuccess,
  updateSDWaiveOffFaliure,

  updateSDDueRequest,
  updateSDDueSuccess,
  updateSDDueFaliure,

  fetchClientAccountIdAgreementListRequest,
  fetchClientAccountIdAgreementListSuccess,
  fetchClientAccountIdAgreementListFaliure,

  fetchAgreementDataForAccountRequest,
  fetchAgreementDataForAccountSuccess,
  fetchAgreementDataForAccountFailure,

  fetchClientAccountProposalListRequest,
  fetchClientAccountProposalListSuccess,
  fetchClientAccountProposalListFailure,

  fetchProposalClientByIdRequest,
  fetchProposalClientByIdSuccess,
  fetchProposalClientByIdFailure,

  fetchProposalClientByIdOtViewRequest,
  fetchProposalClientByIdOtViewSuccess,
  fetchProposalClientByIdOtViewFailure,

  createProposalAccountSuccess,
  createProposalAccountFailure,
  createProposalAccountRequest,

  fetchAccountBookingListRequest,
  fetchAccountBookingListSuccess,
  fetchAccountBookingListFailure,

  fetchBookingByAccountListRequest,
  fetchBookingByAccountListSuccess,
  fetchBookingByAccountListFaliure,

  syncFailedMemberRequest,
  syncFailedMemberSuccess,
  syncFailedMemberFaliure

} = AccountSlice.actions;

/**
 *
 * @param {*} store
 * @returns {AccountStoreAccount['AccountList']}
 */
export const getAccountListState = (store) => store.Account?.accountList;
export const getAccountCompanyListState = (store) =>
  store.Account?.accountCompanyList;
export const getAccountCreateState = (store) => store.Account?.createAccount;
export const getAccountUpdateState = (store) => store.Account?.updateAccount;
export const getAccountDropDownListState = (store) =>
  store.Account?.accountDropDownList;
export const getByIdStateAccount = (store) => store.Account?.accountgetById;
export const getLocationAccountListState = (store) =>
  store.Account?.locationAccountList;
export const getGenerateClientIdStateAccount = (store) =>
  store.Account?.generateClientId;
export const getDm = (store)=>
 store.Account?.generateClientDm;
export const getUpdateAccountProfileListState = (store) =>
  store.Account?.accountProfileList;
export const getEditAccountProfileListState = (store) =>
  store.Account?.accountProfileList;
export const getSDWaiveOffListState = (store) => store.Account?.accountList;
export const getClientAccountIdAgreementListState = (state) =>
  state.Account?.clientAccountIdAgreementList;
export const getAgreementDataAccountState = (store) =>
  store.Account?.agreementDataForAccount;
  export const getProposalDataAccountState = (store) =>
  store.Account?.ProposalDataForAccount;
  export const getGenerateProposalDataAccountState = (store) =>
  store.Account?.ProposalDataForAccountGenerate;
  export const getProposalDataForOtViewState = (store) =>
  store.Account?.ProposalDataForOtView;
  export const getAccountProposalDataState = (store) =>
  store.Account?.ProposalDataUpdate;
  export const getAccountBookingListState = (store) => store.Account?.accountBookingList;
  export const getBookingByAccountListState = (store) => store.Account?.bookingByAccountList;
  export const getSyncFailedDataState = (store) => store.Account?.syncMemberData;
export default AccountSlice.reducer;
